export const GET_VENDORS = 'GET_VENDORS'
export const GET_VENDORS_FAILED = 'GET_VENDORS_FAILED'
export const GET_VENDORS_SUCCEEDED = 'GET_VENDORS_SUCCEEDED'

export const GET_RECENT_VENDORS = 'GET_RECENT_VENDORS'
export const GET_RECENT_VENDORS_FAILED = 'GET_RECENT_VENDORS_FAILED'
export const GET_RECENT_VENDORS_SUCCEEDED = 'GET_RECENT_VENDORS_SUCCEEDED'

export const RESET_VENDOR_FILTERS = 'RESET_VENDOR_FILTERS'
export const TOGGLE_VENDOR_FILTER_DRAWER = 'TOGGLE_VENDOR_FILTER_DRAWER'

export const FETCH_VENDOR_ALIASES = 'FETCH_VENDOR_ALIASES'
export const FETCH_VENDOR_ALIASES_FAILED = 'FETCH_VENDOR_ALIASES_FAILED'
export const FETCH_VENDOR_ALIASES_SUCCEEDED = 'FETCH_VENDOR_ALIASES_SUCCEEDED'

export const ADD_VENDOR_ALIAS = 'ADD_VENDOR_ALIAS'
export const ADD_VENDOR_ALIAS_FAILED = 'ADD_VENDOR_ALIAS_FAILED'
export const ADD_VENDOR_ALIAS_SUCCEEDED = 'ADD_VENDOR_ALIAS_SUCCEEDED'

export const CHANGE_VENDOR_ALIAS = 'CHANGE_VENDOR_ALIAS'
export const CHANGE_VENDOR_ALIAS_FAILED = 'CHANGE_VENDOR_ALIAS_FAILED'
export const CHANGE_VENDOR_ALIAS_SUCCEEDED = 'CHANGE_VENDOR_ALIAS_SUCCEEDED'

export const DELETE_VENDOR_ALIAS = 'DELETE_VENDOR_ALIAS'
export const DELETE_VENDOR_ALIAS_FAILED = 'DELETE_VENDOR_ALIAS_FAILED'
export const DELETE_VENDOR_ALIAS_SUCCEEDED = 'DELETE_VENDOR_ALIAS_SUCCEEDED'

export const ADD_VENDOR_TAG = 'ADD_VENDOR_TAG'
export const ADD_VENDOR_TAG_FAILED = 'ADD_VENDOR_TAG_FAILED'
export const ADD_VENDOR_TAG_SUCCEEDED = 'ADD_VENDOR_TAG_SUCCEEDED'

export const CHANGE_VENDOR_TAG = 'CHANGE_VENDOR_TAG'
export const CHANGE_VENDOR_TAG_FAILED = 'CHANGE_VENDOR_TAG_FAILED'
export const CHANGE_VENDOR_TAG_SUCCEEDED = 'CHANGE_VENDOR_TAG_SUCCEEDED'

export const DELETE_VENDOR_TAG = 'DELETE_VENDOR_TAG'
export const DELETE_VENDOR_TAG_FAILED = 'DELETE_VENDOR_TAG_FAILED'
export const DELETE_VENDOR_TAG_SUCCEEDED = 'DELETE_VENDOR_TAG_SUCCEEDED'

export const FETCH_VENDORS = 'FETCH_VENDORS'
export const FETCH_VENDORS_FAILED = 'FETCH_VENDORS_FAILED'
export const FETCH_VENDORS_SUCCEEDED = 'FETCH_VENDORS_SUCCEEDED'
